// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05f8c4a7","667":"f6e6f03d","977":"c13a0d74"}[chunkId] + ".chunk.js";
};